import {Component, Inject, OnInit, DOCUMENT} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import {ImageCarouselComponent} from "../image-carousel/image-carousel.component";
import {BannerLogoComponent} from "../banner-logo/banner-logo.component";
import {RouterLink} from "@angular/router";
import {ClickCardComponent} from "../click-card/click-card.component";
import { Location } from '@angular/common';
import {SeoService} from "../seo-service.service";

@Component({
  selector: 'app-home',
  imports: [
    ImageCarouselComponent,
    BannerLogoComponent,
    ClickCardComponent,
  ],
  templateUrl: './home.component.html',
  standalone: true,
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    private seo: SeoService
  ) {}

  // for crawlers
  ngOnInit() {
    this.seo.updateMeta(
      'Sydney Advanced Endocrinology',
      'Multidisciplinary endocrinology care in Sydney. Specialists in hormone-related conditions, diabetes, thyroid disorders, PCOS, menopause & metabolic issues.',
      ''
    );
  }
}
